/**
 * @module constants/regexpSpecialCharacters
 * @private
 * @description Exports special characters for RegExp.
 */

/**
 * @const
 * @name module:constants/regexpSpecialCharacters~regexpSpecialCharacters
 * @type {String[]}
 */
export default [
  '.',
  '+', '*', '?',
  '(', ')',
  '[', ']',
  '{', '}',
  '<', '>',
  '^', '$',
  '!',
  '=',
  ':',
  '-',
  '|',
  ',',
  '\\'
];
